import Service from "../Service";

const power_bi = {

    getAllPowerBi() {
        console.log("getAllPowerBixxx")
        return Service.get(`/api/power-bi/all`);
    }

};

export default power_bi;
